/**
 * 考试的公共页面
 */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Descriptions, Breadcrumb, message } from 'antd';
import moment from 'moment';
import SignModal from "./SignModal";
import { getExternalInfoList, signExamExternal } from "../../apis/public";
import MenuComp from '../../College/layout/Menu';
import "./index.less";

interface IProps extends RouteComponentProps {};
interface IState {
  examId: string;
  examInfo: any;
  showSignModal: boolean;
}


class ExamIndex extends Component<IProps, IState> {
  state: IState = {
    examId: "",
    examInfo: {},
    showSignModal: false
  }

  componentDidMount() {
    console.log(this.props);
    const { params }: any = this.props.match;
    this.setState({
      examId: params.id
    }, () => {
      this.initialData();
    })
  }
  // 获取内部考考试数据
  initialData = () => {
    const { examId } = this.state;
    getExternalInfoList({id: examId}).then((res: any) => {
      if (res && res.code === 0) {
        const { data = {}} = res;
        this.setState({
          examInfo: data ? data :{}
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }
  // 是否显示弹窗
  changeSignModal = () => {
    this.setState({
      showSignModal: !this.state.showSignModal
    })
  }
  // 报名
  onModalOk = (values: any) => {
    console.log(values);
    const { examId } = this.state;
    const params = {
      ...values,
      exam_id: examId
    };
    signExamExternal(params).then((res: any) => {
      if (res && res.code === 0) {
        this.changeSignModal();
        message.success('报名成功，稍后请注意邮件通知！');
      } else {
        res && message.error(res.msg);
      }
    })
  }
  // 返回
  goPage = (url: string) => {
    this.props.history.push(url);
  }
  render() {
    const { examInfo, showSignModal } = this.state;
    const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify(null)) || {};
    return (
      <div className="public_exam">
        {
          showSignModal &&
          <SignModal
            showModal={showSignModal}
            onModalOk={this.onModalOk}
            closeModal={this.changeSignModal}
          />
        }
        {/* <div className="public_nav">
          <div className="nav">
            <div className="logo">
              <img src={Logo} alt=""/>
            </div>
          </div>
        </div> */}
        <MenuComp userinfo={userinfo} />
        <div className="public_inner" style={{marginTop: 20}}>
          <div className="inner" >
            <Breadcrumb style={{marginBottom: 20}}>
                <Breadcrumb.Item onClick={this.goPage.bind(this, '/')}>
                  <span style={{cursor: 'pointer'}}>首页</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item onClick={this.goPage.bind(this, '/activity')}>
                  <span style={{cursor: 'pointer'}}>考试列表</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item>考试详情</Breadcrumb.Item>
              </Breadcrumb>
            <div className="exam_detail" style={{backgroundColor: '#FFF', padding: 20}}>
              <Descriptions
                // title="考试详情" 
                bordered
                // size={this.state.size}
                // extra={<Button type="primary" onClick={this.returnGo}>返回</Button>}
              >
                <Descriptions.Item label="考试标题" span={2}>{examInfo.exam_title}</Descriptions.Item>
                <Descriptions.Item label="考试次数">{examInfo.nums}</Descriptions.Item>
                <Descriptions.Item label="考试摘要" span={3}>{examInfo.exam_abstract}</Descriptions.Item>
                <Descriptions.Item label="考试时间" span={3}>
                  {moment(examInfo.start_time * 1000).format("YYYY-MM-DD HH:mm")} ~ 
                  {moment(examInfo.end_time * 1000).format("YYYY-MM-DD HH:mm")} </Descriptions.Item>
                <Descriptions.Item label="考试描述" span={3}>
                  <div dangerouslySetInnerHTML={{__html: examInfo.exam_describe}}></div>
                </Descriptions.Item>
              </Descriptions>
              <div className="exam_detail_bot">
                <Button type="primary" size="large" onClick={this.changeSignModal}>我要报名</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ExamIndex;
